/**
 * Platform host(s) for identity-root / subdomain detection.
 * Injected at runtime via window.ENV.PLATFORM_HOSTS so no host is hardcoded in the bundle.
 */
export function getPlatformHosts() {
  const list = typeof window !== "undefined" && window.ENV && Array.isArray(window.ENV.PLATFORM_HOSTS) ? window.ENV.PLATFORM_HOSTS : [];
  return list.length ? list : [];
}

export function getSuperAdminHosts() {
  const list = typeof window !== "undefined" && window.ENV && Array.isArray(window.ENV.SUPER_ADMIN_HOSTS) ? window.ENV.SUPER_ADMIN_HOSTS : [];
  return list.length ? list : [];
}
